import { render } from "./humanityCourseCreate.vue?vue&type=template&id=6d639b7d&scoped=true"
import script from "./humanityCourseCreate.vue?vue&type=script&lang=js"
export * from "./humanityCourseCreate.vue?vue&type=script&lang=js"

import "./humanityCourseCreate.vue?vue&type=style&index=0&id=6d639b7d&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d639b7d"]])

export default __exports__